export default {
      id: "icon--chevron-right-usage",
      viewBox: "0 0 7 13",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--chevron-right-usage",
      toString: function () {
        return this.url;
      }
    }